// extracted by mini-css-extract-plugin
export default {"root":"List_root__45mSV"};